export const StringifyNestedObjects =(payload, encodedFields, removedFields, encodeAll) => {
//encodedFields is an array of keys that references items that need to be encoded
let output = {}


if(encodeAll){
  output.data = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
}else{
  Object.keys(payload).forEach((item)=>{
      if(encodedFields.includes(item)){
        output[item] = btoa(JSON.stringify(payload[item]));
      }else if(removedFields.includes(item)){
        output[item] = '';
      }else{
        if(Array.isArray(payload[item])){
          output[item] = [];
          payload[item].forEach((nestedItem)=>{
            output[item].push(JSON.stringify(nestedItem));
          })
        }else{
          output[item] = JSON.stringify(payload[item]);
        }
      }
  })
}

//console.log(output)
return output;
}
